import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

import { useOrg } from "@/api/queries/orgs";
import { useUser } from "@/api/queries/users";

type ProfileMenuProps = {
  menuItems: Array<{ text: string; onClick: () => void }>;
};

const ProfileMenu = ({ menuItems }: ProfileMenuProps) => {
  const { data: org } = useOrg();
  const { data: user } = useUser();

  return (
    <Menu as="div" className="relative block px-3 text-left">
      <MenuButton
        className="
          group w-full rounded-md px-3.5 py-2 text-left text-sm font-medium text-slate-700
          hover:bg-slate-200
          focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-slate-100 focus:outline-none
        "
      >
        <span className="flex w-full items-center justify-between">
          <span className="flex min-w-0 items-center justify-between space-x-3">
            <span className="inline-flex size-10 items-center justify-center rounded-full bg-gray-800">
              <span className="text-lg leading-none font-normal text-white">
                {user?.email.toUpperCase().slice(0, 2)}
              </span>
            </span>
            <span className="flex min-w-0 flex-1 flex-col space-y-0.5">
              <span className="truncate text-sm font-normal text-slate-600">{user?.email}</span>
              <span className="truncate text-xs font-normal text-slate-400">{org?.name}</span>
            </span>
          </span>
        </span>
      </MenuButton>
      <MenuItems
        anchor="right end"
        transition
        className="
          z-10 w-60 origin-top rounded-md bg-white shadow-lg ring-1 ring-black/5 transition duration-100 ease-out
          [--anchor-gap:var(--spacing-1)]
          focus:outline-none
          data-closed:scale-95 data-closed:opacity-0
        "
      >
        <div className="w-full py-1">
          {menuItems.map((menuItem, key) => (
            <MenuItem key={key}>
              {({ focus }) => (
                <button
                  onClick={menuItem.onClick}
                  className={`
                    ${focus ? "bg-slate-100 text-slate-900" : "text-slate-700"}
                    flex w-full px-4 py-2 text-sm
                  `}
                >
                  {menuItem.text}
                </button>
              )}
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Menu>
  );
};
export default ProfileMenu;
